import React from 'react';
import { Descriptions } from 'antd';
import { PropertyInformation } from 'common/models';

const PropertyInformationDescriptions: React.FC<{
  county: string;
  propertyInformation: PropertyInformation;
}> = (props: { county: string; propertyInformation: PropertyInformation }) => {
  const { county, propertyInformation } = props;
  const { itemNumber, schoolCode, swissCode, city, address } =
    propertyInformation;

  return (
    <Descriptions
      title="Property Information"
      bordered
      size={'small'}
      column={3}
    >
      <Descriptions.Item label="County" span={1}>
        {county}
      </Descriptions.Item>
      <Descriptions.Item label="Town/City/Village" span={1}>
        {city}
      </Descriptions.Item>
      <Descriptions.Item label="Address" span={1}>
        {address}
      </Descriptions.Item>
      <Descriptions.Item label="Item Number" span={1}>
        {itemNumber}
      </Descriptions.Item>
      <Descriptions.Item label="School Code" span={2}>
        {schoolCode}
      </Descriptions.Item>
      <Descriptions.Item label="Swis Code">{swissCode}</Descriptions.Item>
    </Descriptions>
  );
};

export default PropertyInformationDescriptions;
